export default "__VITE_ASSET__BcFbsR6P__"